import { useState } from "react";
import { Button } from "@mui/material";

import { EditView } from "./EditView";
import { ProjectConfigSchema } from "hooks/pavm/base";

const EditDialog = ({
  type,
  config,
  version,
  disabled = false,
}: {
  type: string;
  version: string;
  disabled?: boolean;
  config: ProjectConfigSchema;
}) => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div>
      <Button
        size="small"
        color="secondary"
        variant="contained"
        disabled={disabled}
        onClick={handleOpen}
      >
        Edit
      </Button>

      <EditView
        type={type}
        title={config.host}
        config={config}
        version={version}
        open={open}
        onClose={handleClose}
      />
    </div>
  );
};

export default EditDialog;
